/**
 * Missions with no numeric saved coordinates. Custom/runtime overrides do not
 * count — only the coordinates stored on the task itself.
 */
export function unpositionedMissionIds(tasks) {
  const ids = [];
  for (const task of tasks || []) {
    if (!task?.id) continue;
    if (!Number.isFinite(task.x) || !Number.isFinite(task.y)) ids.push(task.id);
  }
  ids.sort();
  return ids;
}
